import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2c00db4c&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QPageSticky,QTable,QTr,QTd,QBtn,QIcon,QColor} from 'quasar'
component.options.components = Object.assign({QPage,QPageSticky,QTable,QTr,QTd,QBtn,QIcon,QColor}, component.options.components || {})
